import { render, staticRenderFns } from "./PreviewLayout.vue?vue&type=template&id=6bf566e4&scoped=true"
import script from "./PreviewLayout.vue?vue&type=script&lang=js"
export * from "./PreviewLayout.vue?vue&type=script&lang=js"
import style0 from "./PreviewLayout.vue?vue&type=style&index=0&id=6bf566e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf566e4",
  null
  
)

export default component.exports